import * as React from "react";

const Auth0 = () => (
  <svg
    width="122px"
    height="44px"
    viewBox="0 0 122 44"
    version="1.1"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      transform="translate(-1600.000000, -1337.000000) translate(-17.000000, 1337.000000) translate(1617.517734, 0.000000)"
      fill="#000"
      stroke="none"
      strokeWidth={1}
      fillRule="evenodd"
    >
      <path
        d="M113.802 11.553c-2.116 0-3.905.996-5.175 2.882-1.262 1.874-1.929 4.49-1.929 7.565s.667 5.69 1.93 7.565c1.27 1.886 3.058 2.882 5.174 2.882 2.116 0 3.905-.996 5.175-2.882 1.262-1.874 1.929-4.49 1.929-7.565s-.667-5.69-1.93-7.565c-1.269-1.886-3.058-2.882-5.174-2.882zm0 18.305c-1.011 0-1.81-.572-2.444-1.75-.764-1.422-1.185-3.591-1.185-6.108 0-2.517.421-4.687 1.185-6.109.634-1.177 1.433-1.75 2.444-1.75s1.81.573 2.444 1.75c.764 1.422 1.185 3.592 1.185 6.109s-.42 4.687-1.185 6.109c-.633 1.177-1.433 1.75-2.444 1.75zm-45.85-10.694v8.987a4.302 4.302 0 0 0 4.296 4.296c2.066 0 3.628-1.025 4.203-1.466a.123.123 0 0 1 .192.062l.347 1.135h2.56V19.164h-3.29v9.73a.124.124 0 0 1-.066.11c-.619.32-1.84.855-3.062.855a1.893 1.893 0 0 1-1.89-1.891v-8.804h-3.29zm32.943 13.013h3.29v-8.986a4.302 4.302 0 0 0-4.296-4.297c-1.744 0-3.143.75-3.822 1.197a.122.122 0 0 1-.19-.103v-8.165h-3.29v20.354h3.29v-9.73c0-.047.026-.089.067-.11.618-.319 1.839-.854 3.061-.854.505 0 .98.196 1.337.553.357.357.553.832.553 1.337v8.804zM81.922 21.753h2.002c.068 0 .123.055.123.122v7.16a3.417 3.417 0 0 0 3.413 3.412c.682 0 1.355-.099 2.003-.293v-2.35c-.378.033-.812.054-1.12.054a1.008 1.008 0 0 1-1.006-1.006v-6.977c0-.068.055-.123.123-.123h2.003v-2.588H87.46a.123.123 0 0 1-.123-.123v-4.297h-3.29v4.297a.123.123 0 0 1-.123.123h-2.002v2.589zM62.69 32.177h3.422l-5.205-18.152a3.428 3.428 0 0 0-3.28-2.472 3.428 3.428 0 0 0-3.281 2.472L49.14 32.177h3.422l1.507-5.254a.123.123 0 0 1 .118-.088h6.877c.055 0 .103.036.118.088l1.507 5.254zm-2.437-7.93H55a.123.123 0 0 1-.118-.158l2.626-9.157a.123.123 0 0 1 .236 0l2.626 9.157a.122.122 0 0 1-.02.108.122.122 0 0 1-.098.05z"
        fillRule="nonzero"
      />
      <path
        d="M31.312 35.583l-4.413-13.584 11.552-8.393h-14.28L19.758.024 19.757.02h14.281l4.415 13.585.004-.002c2.563 7.881-.077 16.845-7.145 21.98zm-23.109 0l-.004.002 11.555 8.395 11.558-8.397-11.554-8.395-11.555 8.395zm-7.142-21.98c-2.698 8.308.434 17.111 7.14 21.981v-.004l4.414-13.583-11.549-8.39h14.276L19.756.022V.02H5.475L1.061 13.603z"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Auth0;
